module.exports = __webpack_public_path__ + "static/media/comment-manage.d37c5584.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/comment-manage.png
// module id = 1928
// module chunks = 6